import { useState, useEffect } from "react";

const MAX_RESOURCE_SNAPSHOTS = 300;

export default function useInfrastructureSnapshots(systemStats, bankserverHealth) {
  const [resourceSnapshots, setResourceSnapshots] = useState([]);

  useEffect(() => {
    const now = Date.now();
    const avg = (values) => {
      const nums = values.filter((v) => Number.isFinite(Number(v))).map(Number);
      return nums.length ? Math.round(nums.reduce((a, b) => a + b, 0) / nums.length) : 0;
    };

    const nextSnapshot = {
      ts: now,
      cpu: avg([systemStats?.apiGateway?.cpu, systemStats?.database?.cpu, bankserverHealth?.cpu]),
      memory: avg([systemStats?.apiGateway?.memory, systemStats?.database?.memory, bankserverHealth?.memory]),
    };

    setResourceSnapshots((prev) => {
      // Avoid duplicate snapshots within 4 seconds
      const tooSoon = prev.length > 0 && now - prev[prev.length - 1].ts < 4000;
      if (tooSoon) return [...prev.slice(0, -1), nextSnapshot];
      return [...prev, nextSnapshot].slice(-MAX_RESOURCE_SNAPSHOTS);
    });
  }, [systemStats, bankserverHealth]);

  return resourceSnapshots;
}
